import { StudentSectionSettingTypeCodes } from 'const';
import { cultureWidgetVisibilityHooks } from 'hooks';
import { cultureOnlineEventsSelector, cultureVisitingsSelector } from 'selectors';
import { getDataLoadRequests } from 'utils';

import { SectionLoaderConfig } from './types';

export const getCultureLoaderConfig = (): SectionLoaderConfig => {
  return [
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.cultureOfflineVisiting,
      requests: getDataLoadRequests().cultureOfflineVisitings,
      loadingSelector: cultureVisitingsSelector,
      dataSelector: (state) => cultureVisitingsSelector(state).content.length > 0,
      useWidgetVisibility: cultureWidgetVisibilityHooks.useOfflineVisitings,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.cultureOnlineVisiting,
      requests: getDataLoadRequests().cultureOnlineVisitings,
      loadingSelector: cultureOnlineEventsSelector,
      dataSelector: (state) => cultureOnlineEventsSelector(state).content.length > 0,
      useWidgetVisibility: cultureWidgetVisibilityHooks.useOnlineVisitings,
    },
  ];
};
